import responseSettings from './response_settings'

export default function (models = []) {
  const instructionsDisplayParams = ['placeholder_steps']

  const settings = responseSettings(models)
  if (!settings.webOnly && !settings.smsOnly && !settings.both) {
    // No activities in the deck.
    // Choosing to show both sms and web instructions for this case for now.
    instructionsDisplayParams.push('web', 'sms')
  } else if (!settings.webOnly && !settings.smsOnly && settings.both) {
    instructionsDisplayParams.push('web', 'sms')
  } else if (!settings.webOnly && settings.smsOnly && !settings.both) {
    instructionsDisplayParams.push('sms')
  } else if (!settings.webOnly && settings.smsOnly && settings.both) {
    instructionsDisplayParams.push('sms')
  } else if (settings.webOnly && !settings.smsOnly && !settings.both) {
    instructionsDisplayParams.push('web')
  } else if (settings.webOnly && !settings.smsOnly && settings.both) {
    instructionsDisplayParams.push('web')
  } else if (settings.webOnly && settings.smsOnly) {
    // Conflicting response settings.
    // Choosing to show both sms and web instructions for this case for now.
    instructionsDisplayParams.push('web', 'sms')
  }

  return instructionsDisplayParams
}
